import React from "react";
import logo from "../../assets/img/theme/blinx.png"; // Ensure the correct path

const LoginFooter = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer style={{ textAlign: "center", fontSize: "12px", lineHeight: "1.4", marginTop: "5px" }}>
            {/* Logo on the first line */}
            <div>
                <img src={logo} alt="BLiNX Logo" style={{ height: "16px", verticalAlign: "middle" }} />
            </div>

            {/* Copyright on the second line */}
            <div>
                &copy; {currentYear} BLiNX Lanka (PVT) LTD. | College Management System - Mini ERP by BLiNX. All Rights Reserved.
            </div>

            {/* Contact on the third line */}
            <div>
                <a href="mailto:info@blinx.lk">info@blinx.lk</a>
            </div>
        </footer>
    );
};

export default LoginFooter;
